module.exports = __webpack_public_path__ + "_/node_modules/@reverbdotcom/commons/design-system/icons/payment-card/sofort-payment-card-0b3947d4481a8faffcbf2e5913c87b96.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@reverbdotcom/commons/design-system/icons/payment-card/sofort-payment-card.svg
// module id = g1aU
// module chunks = 24